import { useI18n } from "@/i18n";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer className="mt-24 border-t border-[#EBDDD3] bg-[#F2E8DF]/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="space-y-3">
          <a href="/"><img src="/mymoalem-header-logo.png" alt="MyMoalem" className="h-14 w-auto" /></a>
          <p className="text-sm text-[#8C7A70] max-w-xs">{t("footer.tagline")}</p>
        </div>
        <div className="flex flex-col gap-2 md:items-center">
          <a href="/#pricing" data-testid="footer-pricing" className="text-sm text-[#5A4B45] hover:text-[#C65338]">{t("footer.pricing")}</a>
          <a href="/contact" data-testid="footer-contact" className="text-sm text-[#5A4B45] hover:text-[#C65338]">{t("footer.contact")}</a>
          <a href="/legal" data-testid="footer-legal" className="text-sm text-[#5A4B45] hover:text-[#C65338]">{t("footer.legal")}</a>
          <a href="/impressum" data-testid="footer-imprint" className="text-sm text-[#5A4B45] hover:text-[#C65338]">{t("footer.imprint")}</a>
          <a href="/privacy" data-testid="footer-privacy" className="text-sm text-[#5A4B45] hover:text-[#C65338]">{t("footer.privacy")}</a>
        </div>
        <div className="text-sm text-[#8C7A70] md:text-right">
          © {new Date().getFullYear()} itnetic Group S.A.R.L. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};